import { defineDirective, ExplorerContext, IDatalayerViewerFactory, IDatalayerViewManager, LayerTypeId, LmNode } from "../omnia"

export class ViewerCtrl {

    static create() {
        const def = defineDirective(ViewerCtrl, null, {
            node: "=",
            context: "="
        })

        def.template = "<select class='form-control' ng-model='vm.viewer' ng-options='v as v.name for v in vm.viewers' ng-click='$event.stopPropagation()'></select>"

        return def

    }

    private mgr: IDatalayerViewManager

    public node: LmNode
    public context: ExplorerContext
    public type: LayerTypeId

    public viewers: IDatalayerViewerFactory[]

    $onInit() {
        const mgr = this.mgr = this.context.viewManager
        const node = this.node
        const type = this.type = node.layerType.TypeId
        this.viewers = mgr.getViewers(type)
    }

    get viewer() {
        const { mgr } = this
        return mgr ? mgr.getCurrentViewer(this.type) : undefined
    }

    set viewer(value) {
        this.context.setViewer(this.type, value)
    }

}
